import { createLifeGrid } from '../core/cells';

export const blinker = createLifeGrid({ 
  "0,0": true,
  "1,0": true,
  "2,0": true,
});

export const blinker2 = createLifeGrid({
  "0,1": true,
  "1,1": true,
  "2,1": true,
});

export const beacon = createLifeGrid({
  "0,2": true,
  "0,3": true,
  "1,2": true,
  "1,3": true,

  "2,0": true,
  "3,0": true,
  "2,1": true,
  "3,1": true
});

export const beaconA2 = createLifeGrid({
  "0,2": true,
  "0,3": true,
  "1,3": true,
  "2,0": true,
  "3,0": true,
  "3,1": true
});

export const toad = createLifeGrid({
  "1,0": true,
  "2,0": true,
  "3,0": true,
  "0,1": true,
  "1,1": true,
  "2,1": true
});

export const pulsar = createLifeGrid({
  // Top section
  "2,0": true,
  "3,0": true,
  "4,0": true,
  "8,0": true,
  "9,0": true,
  "10,0": true,
  
  "0,2": true,
  "5,2": true,
  "7,2": true,
  "12,2": true,
  "0,3": true,
  "5,3": true,
  "7,3": true,
  "12,3": true,
  "0,4": true,
  "5,4": true,
  "7,4": true,
  "12,4": true,
  
  "2,5": true,
  "3,5": true,
  "4,5": true,
  "8,5": true,
  "9,5": true,
  "10,5": true,
  
  // Middle
  "2,7": true,
  "3,7": true,
  "4,7": true,
  "8,7": true,
  "9,7": true,
  "10,7": true,
  
  // Bottom section (symmetric)
  "0,8": true,
  "5,8": true,
  "7,8": true,
  "12,8": true,
  "0,9": true,
  "5,9": true,
  "7,9": true,
  "12,9": true,
  "0,10": true,
  "5,10": true,
  "7,10": true,
  "12,10": true,
  
  "2,12": true,
  "3,12": true,
  "4,12": true,
  "8,12": true,
  "9,12": true,
  "10,12": true
});

export const pentadecathlon = createLifeGrid({
  "3,2": true,
  "4,2": true,
  "2,3": true,
  "5,3": true,
  "2,4": true,
  "5,4": true,
  "2,5": true,
  "5,5": true,
  "2,6": true,
  "5,6": true,
  "2,7": true,
  "5,7": true,
  "2,8": true,
  "5,8": true,
  "2,9": true,
  "5,9": true,
  "3,10": true,
  "4,10": true
});